import { ModalProps, Space } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskUpdatePhasePayload } from 'api/tasks';
import { DateValue } from 'components/atoms/due-date-picker';
import { Modal } from 'components/atoms/modal';
import { Task } from 'data/tasks';
import { BasicProjectPhase, RadioOptions } from './radio-options';
import { MoveTaskAlertStyled } from './styled';
import { toReadableDates } from './utils';

interface Props extends ModalProps {
  task: Task;
  projectPhase: BasicProjectPhase;
  confirmLoading: boolean;
  onSubmit: (payload: TaskUpdatePhasePayload) => Promise<unknown>;
}

enum MoveTaskRadioOptions {
  Automatic = 1,
  Custom,
}

export const MoveTaskAlertModal: FC<Props> = ({
  task,
  projectPhase,
  onOk,
  confirmLoading,
  onSubmit,
  ...restProps
}) => {
  const { dueDate, taskName, startDate } = task;
  const [state, setState] = useState(MoveTaskRadioOptions.Automatic);
  const [dates, setDates] = useState<[DateValue, DateValue]>([
    startDate ?? null,
    dueDate ?? null,
  ]);

  return (
    <Modal
      {...restProps}
      visible
      closable={false}
      confirmLoading={confirmLoading}
      destroyOnClose
      title={
        <Space direction="vertical">
          <MoveTaskAlertStyled.Title>
            <FormattedMessage id="task.move_to_phase.alert.title" />
          </MoveTaskAlertStyled.Title>
          <MoveTaskAlertStyled.SubTitle>
            {taskName}
          </MoveTaskAlertStyled.SubTitle>
        </Space>
      }
      onOk={async () => {
        await onSubmit({
          projectPhase: { projectPhaseId: projectPhase.projectPhaseId },
          startDate: dates[0],
          dueDate: dates[1],
        });
      }}
    >
      <FormattedMessage
        id="task.move_to_phase.alert.description"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
          taskDates: toReadableDates([startDate, dueDate]),
          phaseName: projectPhase.projectPhaseName,
          phaseDates: toReadableDates([
            projectPhase.startDate,
            projectPhase.dueDate,
          ]),
        }}
      />
      <RadioOptions
        projectPhase={projectPhase}
        task={task}
        onDateChange={setDates}
        onChange={setState}
        selected={state}
        dates={dates}
      />
    </Modal>
  );
};
